import React, { useContext, useEffect, useRef } from "react";
import {
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";
import FlexView from "react-flexview/lib";
import { SkyInformationPopover } from "../../Core/Popover/SkyPopover";
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext';

const numOfDronesArr = [...Array(25).keys()]
  .map((k) => k + 1)
  .filter((k) => k > 5);

const acceptedFileTypes = [".csv", ".xls", ".pdf"].join(",");

const FleetInformationPopover = ({children}) => 
(
    <SkyInformationPopover eventId={"fleet"}>
      {children}
    </SkyInformationPopover>
);

export default (props) => {
  const {setFleetFile, setFleetIntendedUser, setYearlyFleetSize, setFleetSize, fleetInformation, intendedUsesLoaded, loadIntendedUses, intendedUses, fleetErrors} = useContext(BuyingInsuranceContextStore);
  const ref = useRef();

  useEffect(() => {
    if(intendedUsesLoaded) return;
    loadIntendedUses();
  },[intendedUsesLoaded])

  const onFileSelected = (e) => {
    if (e.target.files.length === 0) return;
    setFleetFile(e.target.files[0]);
  };

  return (
    <>
      <input
        type="file"
        id="file"
        accept={acceptedFileTypes}
        onChange={onFileSelected}
        ref={ref}
        style={{ display: "none" }}
      />

      <FlexView
        vAlignContent={"center"}
        className="text-body bold black margin-top-basic margin-bottom-small"
      >
        Additional Information
      </FlexView>
      <div className="text-body gray margin-top-6 margin-bottom-small">How many drones do you plan to operate now? <FleetInformationPopover carrier="Global" ><span>This is the number of drones in your fleet that you or your<br/> company will operate during the policy period,<br/> including those your rent/lease/borrow.</span></FleetInformationPopover></div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            variant="outlined"
            value={fleetInformation?.fleetSize}
            onChange={(e) => setFleetSize(e.target.value)}
            className="margin-right-basic"
            label="Number of drones (6-25)"
            error={!!fleetErrors.fleetSize}
            helperText={!!fleetErrors.fleetSize? 'Required' : ''}
          >
            {numOfDronesArr.map((num) => (
              <MenuItem key={num} value={num}>
                {num}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            value={fleetInformation?.fleetIntendedUse}
            variant="outlined"
            className="margin-right-basic"
            onChange={(e) => setFleetIntendedUser(e.target.value)}
            label="What is the main intended use?"
            error={!!fleetErrors.fleetIntendedUse}
            helperText={!!fleetErrors.fleetIntendedUse? 'Required' : ''}
          
          >
            {intendedUses.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <div className="text-body gray margin-top-6 margin-bottom-small">How many drones do you plan to operate in a year’s time? <FleetInformationPopover carrier="Global">This is the number of drones in your fleet that you or your company will<br/> potentially operate in a year’s time, including those you rent/lease/borrow</FleetInformationPopover></div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            variant="outlined"
            value={fleetInformation?.yearlySize}
            onChange={(e) => setYearlyFleetSize(e.target.value)}
            className="margin-right-basic"
            label="Number of drones (6-25)"
            error={!!fleetErrors.yearlySize}
            helperText={!!fleetErrors.yearlySize ? 'Required' : ''}
          >
            {numOfDronesArr.map((num) => (
              <MenuItem key={num} value={num}>
                {num}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
         <div className="text-body gray">If you require coverage for more than 25 drones, please contact us</div>
        </Grid>
      </Grid>
    </>
  );
};
